var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 28,
    viewBox: "0 0 15 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 15.9998H13.0002L14.3335 10.6665H9.66683V7.99984C9.66683 6.6265 9.66683 5.33317 12.3335 5.33317H14.3335V0.853171C13.8988 0.795837 12.2575 0.666504 10.5242 0.666504C6.90416 0.666504 4.3335 2.87584 4.3335 6.93317V10.6665H0.333496V15.9998H4.3335V27.3332H9.66683V15.9998Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3f41b0cccceb7bb5fb7ea2697a729a83.svg";
export { ForwardRef as ReactComponent };